import { useCallback } from 'react';
import { get } from 'lodash';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { MinPageSize, } from '../../components/other/PageSizeSelect/pageSizes';
const usePaginationRouting = (props = {}) => {
    const { defaultPageSize = MinPageSize, defaultPageNumber = 1 } = props;
    const { path, url } = useRouteMatch();
    const history = useHistory();
    const pagingMatch = useRouteMatch([
        `${path}/page/:pageNumber/size/:pageSize`,
        `${path}/page/:pageNumber`,
    ]);
    const pageNumber = Number(get(pagingMatch, 'params.pageNumber', defaultPageNumber));
    const pageSize = Number(get(pagingMatch, 'params.pageSize', defaultPageSize));
    const setPageNumber = useCallback((pageNumber = defaultPageNumber) => {
        history.push(`${url}/page/${pageNumber}/size/${pageSize}`);
    }, [defaultPageNumber, history, pageSize, url]);
    const setPageSize = useCallback((pageSize = defaultPageSize) => {
        history.push(`${url}/page/1/size/${pageSize}`);
    }, [url, history, defaultPageSize]);
    return { pageNumber, pageSize, setPageNumber, setPageSize };
};
export default usePaginationRouting;
